import React, { useEffect, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useSettingsStore from "./store/useSettingsStore";
import Layout from "./components/Layout";

const Home = lazy(() => import("./pages/Home"));
const Catalog = lazy(() => import("./pages/Catalog"));
const CarDetail = lazy(() => import("./pages/CarDetail"));
const Configurator = lazy(() => import("./pages/Configurator"));
const Services = lazy(() => import("./pages/Services"));
const Reviews = lazy(() => import("./pages/Reviews"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogArticle = lazy(() => import("./pages/BlogArticle"));
const About = lazy(() => import("./pages/About"));
const Contacts = lazy(() => import("./pages/Contacts"));
const AdminPanel = lazy(() => import("./pages/AdminPanel"));

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-[var(--ap-bg)]">
    <div className="w-8 h-8 border-2 border-[var(--ap-primary)] border-t-transparent rounded-full animate-spin" />
  </div>
);

function App() {
  const fetchSettings = useSettingsStore(s => s.fetchSettings);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/cars/:slug" element={<CarDetail />} />
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/services" element={<Services />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contacts" element={<Contacts />} />
          </Route>
          <Route path="/administrator-panel" element={<AdminPanel />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
